// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".about-text p{-moz-column-gap:30px;column-gap:30px;line-height:22px;font-size:13px;font-weight:var(--noto-regular)}", ""]);
// Exports
module.exports = exports;
